// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1l7qF","overflowing":"ReadFullNote_overflowing__1E_jB"};